module.exports = __webpack_public_path__ + "f2933f501980e77279933fadb73e2c4a.svg";